import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';

const NotFound = () => {
  // Injectare meta noindex pentru SEO (pagini 404 NU trebuie indexate)
  useEffect(() => {
    // Setare meta noindex
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex,nofollow');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex,nofollow';
      document.head.appendChild(meta);
    }

    // Setare title
    document.title = '404 - Pagina nu a fost găsită | cf-extras.ro';

    // Cleanup (revert la index/follow când părăsim 404)
    return () => {
      const metaRobots = document.querySelector('meta[name="robots"]');
      if (metaRobots) {
        metaRobots.setAttribute('content', 'index,follow');
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-emerald-600 opacity-20">404</h1>
        </div>

        {/* Icon */}
        <div className="mb-8 flex justify-center">
          <div className="bg-white rounded-full p-6 shadow-lg">
            <Search className="w-16 h-16 text-emerald-600" />
          </div>
        </div>

        {/* Message */}
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Pagina nu a fost găsită
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          Ne pare rău, dar pagina pe care o cauți nu există sau a fost mutată.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-colors shadow-lg"
          >
            <Home className="w-5 h-5" />
            Înapoi la Pagina Principală
          </Link>

          <Link
            to="/termeni-conditii"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-emerald-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors border-2 border-emerald-600"
          >
            Termeni și Condiții
          </Link>
        </div>

        {/* Help Text */}
        <div className="mt-12 p-6 bg-white rounded-lg shadow-md">
          <p className="text-sm text-gray-600">
            <strong>Ai nevoie de ajutor?</strong><br />
            Dacă crezi că aceasta este o eroare, te rugăm să ne contactezi la{' '}
            <a href="mailto:contact@cf-extras.ro" className="text-emerald-600 hover:underline">
              contact@cf-extras.ro
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
